// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3xJD5","col":"styles_col__uHYCI"};